import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import classNames from "classnames";
import isNumber from "lodash/isNumber";
import isUndefined from "lodash/isUndefined";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { NEW_PROJECT } from "./constants";
import ProjectEditor from "./projectEditor";
import locale from "./projectEditorPanel.locale";
export const SIZES = {
    MODAL_WIDTH: 400,
    MODAL_HEIGHT: 315
};
function ProjectEditorPanel(props) {
    const [show, setShow] = useState(false);
    const projectIdRef = useRef(props.projectId);
    const [inEditingProgress, setInEditingProgress] = useState(new Set());
    const title = useMemo(() => isUndefined(props.projectId)
        ? ""
        : props.projectId === NEW_PROJECT.Id
            ? locale.CREATE_PROJECT
            : locale.EDIT_PROJECT, [props.projectId]);
    useEffect(() => {
        projectIdRef.current = props.projectId;
        props.projectId && props.onInitialized && props.onInitialized(props.projectId);
        setShow(!isUndefined(props.projectId));
    }, [props.projectId]);
    const handleHideModal = useCallback((e) => {
        if (e)
            props.onClose && props.onClose();
        else
            setShow(false);
    }, [props.onClose]);
    const handleClose = useCallback((projectId) => {
        if (projectId === projectIdRef.current)
            setShow(false);
    }, []);
    const handleEditingInProgress = useCallback((inProgress, projectId) => {
        setInEditingProgress(prev => {
            if (inProgress && prev.has(projectId))
                return prev;
            const result = new Set(prev);
            if (inProgress)
                result.add(projectId);
            else
                result.delete(projectId);
            return result;
        });
    }, []);
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: classNames("modal-padding", isNumber(props.projectId) &&
            inEditingProgress.has(props.projectId) &&
            "no-pointer-events"), shadingColor: shadingLightestColor, className: "bg-blur", title: title, defaultWidth: SIZES.MODAL_WIDTH, defaultHeight: SIZES.MODAL_HEIGHT, isLoading: props.inProgress },
        React.createElement(ProjectEditor, { onHide: handleClose, onEditingInProgress: handleEditingInProgress })));
}
export default memo(ProjectEditorPanel);
